// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__fPVg9","rotation":"SmallLoader_rotation__2rQoE"};